module.exports = __webpack_public_path__ + "img/mezzanine.e6a2a506.svg";